"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var SwitchContext_1 = require("./SwitchContext");
var SwitchIcon = function (_a) {
    var CheckedIcon = _a.CheckedIcon, DefaultIcon = _a.DefaultIcon, className = _a.className, rest = __rest(_a, ["CheckedIcon", "DefaultIcon", "className"]);
    var checked = SwitchContext_1.useSwitchContext().checked;
    var Icon = checked ? CheckedIcon : DefaultIcon;
    return Icon ? (react_1["default"].createElement(Icon, __assign({ className: [checked && 'selected', className] }, rest))) : null;
};
exports["default"] = SwitchIcon;
//# sourceMappingURL=SwitchIcon.js.map